export default {
  LOAD_COMPETENCY_SURVEY_OVERVIEW_PAGE_START: 'LoadCompetencySurveyOverviewPageStart',
  LOAD_COMPETENCY_SURVEY_OVERVIEW_PAGE_END: 'LoadCompetencySurveyOverviewPageEnd',
  SELECT_COMPETENCY_SURVEY_OVERVIEW_PAGE_TAB: 'SelectCompetencySurveyOverviewPageTab',
  CLEAR_COMPETENCY_SURVEY_OVERVIEW_PAGE: 'ClearCompetencySurveyOverviewPage'
};